<template>
    <div v-if="loader" style="height: 300px; line-height: 250px">
        <v-progress-circular indeterminate :size="50"></v-progress-circular>
    </div>
    <div v-else class="row ma-4" style="width: 95%">
        <!-- Order Information -->
        <div class="col-6 justify-content-start ">
            <div class="row">
                <v-card-title class="text-left ma-0">{{ $t("orders.orderNumber") }}</v-card-title>
            </div>
            <div class="d-flex">
                <v-text-field v-model="numCommand" id="orderNumber" name="orderNumber" hide-details
                    persistent-placeholder variant="outlined" readonly class="readonly-field w-100"></v-text-field>
            </div>
        </div>

        <!-- Client Information -->
        <div class="col-6 justify-content-start">
            <div class="row">
                <v-card-title class="text-left ma-0">{{ $t("orders.clientName") }}</v-card-title>
            </div>
            <div class="d-flex">
                <v-text-field :value="client.fullName || 'N/A'" id="clientName" name="clientName" hide-details
                    persistent-placeholder variant="outlined" readonly class="readonly-field w-100"></v-text-field>
            </div>
        </div>

        <div class="col-6 justify-content-start">
            <div class="row">
                <v-card-title class="text-left ma-0">{{ $t("orders.clientEmail") }}</v-card-title>
            </div>
            <div class="d-flex">
                <v-text-field :value="client.email || 'N/A'" id="clientEmail" name="clientEmail" hide-details
                    persistent-placeholder variant="outlined" readonly class="readonly-field w-100"></v-text-field>
            </div>
        </div>

        <!-- Location Information -->
        <div class="col-6 justify-content-start">
            <div class="row">
                <v-card-title class="text-left ma-0">{{ $t("orders.locationLabel") }}</v-card-title>
            </div>
            <div class="d-flex">
                <v-text-field v-model="locationLabel" id="locationLabel" name="locationLabel" hide-details
                    persistent-placeholder variant="outlined" readonly class="readonly-field w-100"></v-text-field>
            </div>
        </div>

        <div class="col-6 justify-content-start">
            <div class="row">
                <v-card-title class="text-left ma-0">{{ $t("orders.address") }}</v-card-title>
            </div>
            <div class="d-flex">
                <v-text-field v-model="locationAdresse" id="address" name="address" hide-details persistent-placeholder
                    variant="outlined" readonly class="readonly-field w-100"></v-text-field>
            </div>
        </div>

        <div class="col-6 justify-content-start">
            <div class="row">
                <v-card-title class="text-left ma-0">{{ $t("orders.postalCode") }}</v-card-title>
            </div>
            <div class="d-flex">
                <v-text-field v-model="locationPostalCode" id="postalCode" name="postalCode" hide-details
                    persistent-placeholder variant="outlined" readonly class="readonly-field w-100"></v-text-field>
            </div>
        </div>

        <!-- Location Map Section -->
        <div class="col-12">
            <div class="row">
                <v-card-title class="text-left ma-0">{{ $t("orders.locationMap") }}</v-card-title>
            </div>
            <div class="location-map-container">
                <div v-if="!locationLatitude || !locationLongitude" class="map-placeholder">
                    <v-icon size="48" color="grey">mdi-map-marker-off</v-icon>
                    <p>{{ $t("orders.noLocationData") }}</p>
                </div>

                <v-btn color="primary" variant="outlined" class="mt-3" :href="mapUrl" target="_blank">
                    <v-icon left class="mr-2">mdi-map-marker</v-icon>
                    {{ $t("orders.viewOnGoogleMaps") }}
                </v-btn>
            </div>
        </div>

        <!-- Products Section -->
        <div class="col-12">
            <div class="row">
                <v-card-title class="text-left ma-0">{{ $t("orders.products") }}</v-card-title>
            </div>
            <v-table theme="white" class="table-responsive rounded-table" style="width: 100%; margin-top: 10px">
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="column-title text-center">
                                {{ $t("orders.productName") }}
                            </th>
                            <th class="column-small text-center">
                                {{ $t("orders.quantity") }}
                            </th>
                            <th class="column-small text-center">
                                {{ $t("orders.unitPrice") }}
                            </th>
                            <th class="column-small text-center">
                                {{ $t("orders.tax") }}
                            </th>
                            <th class="column-small text-center">
                                {{ $t("orders.montantHT") }}
                            </th>
                            <th class="column-small text-center">
                                {{ $t("orders.totalAmount") }}
                            </th>
                            <th class="column-time text-center">
                                {{ $t("orders.purchaseOrder") }}
                            </th>
                            <th class="column-20 text-center">
                                {{ $t("orders.status") }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="product in products" :key="product.idVariant">
                            <!-- Nom du produit -->
                            <td class="column-title border-right">
                                <span>
                                    {{ product.productName }}
                                </span>
                            </td>

                            <!-- Quantité -->
                            <td class="column-small border-right">
                                <span>
                                    {{ product.quantity }}
                                </span>
                            </td>

                            <!-- Prix unitaire HT -->
                            <td class="column-small border-right">
                                <span>
                                    {{ formatPrice(product.unitPrice) }}
                                </span>
                            </td>

                            <!-- Taxe -->
                            <td class="column-small border-right">
                                <span>
                                    {{ product.tax }}%
                                </span>
                            </td>

                            <!-- Montant HT -->
                            <td class="column-small border-right">
                                <span>
                                    {{ formatPrice(product.totalPrice) }}
                                </span>
                            </td>

                            <!-- Montant TTC -->
                            <td class="column-small border-right">
                                <span>
                                    {{ formatPrice(product.totalPriceTTC) }}
                                </span>
                            </td>
                            <!-- End Collection Time -->
                            <td class="column-time border-right">
                                <v-btn v-if="product.purchaseOrderReference" text color="#114ef7"
                                    @click="fetchPurchaseOrderDetails(product.purchaseOrderId)">
                                    {{ product.purchaseOrderReference }}
                                </v-btn>
                                <div v-else>
                                    <span>
                                        {{ product.remainingTime }}
                                    </span>
                                </div>
                            </td>
                            <td class="column-20 border-right">
                                <span>
                                    {{ GetStatusValue(product.validationItemStatus) }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-table>

            <div class="col-12 totals">
                <p class="align-right">
                    {{ $t("purchaseOrder.montantHT") }} :
                    <strong>{{ formatPrice(totalAmountHT) }}</strong>
                </p>

                <div v-for="(amount, tax) in totaltaxs" :key="tax">
                    <p class="align-right">
                        <span>
                            {{ $t("purchaseOrder.taxAmount") }} {{ tax }}% :
                            {{ formatPrice(amount) }}
                        </span>
                    </p>
                </div>

                <v-divider class="custom-divider"></v-divider>

                <p class="align-right">
                    Total :
                    <strong>{{ formatPrice(grandTotal) }}</strong>
                </p>
            </div>
        </div>
    </div>

    <template v-if="selectedPurchaseOrder">
        <OrderPurchaseOrder :Id="selectedPurchaseOrder.id" :idPurchaseOrder="selectedPurchaseOrder.id"
            :getPurchaseOrder="selectedPurchaseOrder" @close="selectedPurchaseOrder = null" />
    </template>
</template>

<script>
import { formatPrice, getOrderById, getPurchaseOrderById } from "@/api/index";
import OrderPurchaseOrder from "./OrderPurchaseOrder.vue";

export default {
    components: { OrderPurchaseOrder },
    data: () => ({
        loader: true,
        idCommand: "",
        numCommand: null,
        status: null,
        locationLabel: "",
        locationAdresse: "",
        locationPostalCode: "",
        locationLatitude: "",
        locationLongitude: "",
        createdDate: "",
        createdBy: "",
        client: {
            email: "",
            fullName: "",
        },
        products: [],
        commandTotalPrice: 0,
        countdownIntervals: {},
        selectedPurchaseOrder: null,
        editRequestDialog: false,
    }),
    created() {
        const orderId = this.$route.params.id;
        this.getOrderDetails(orderId);
    },
    methods: {
        formatPrice(price) {
            return formatPrice(price)
        },
        GetStatusValue(value) {
            switch (value) {
                case 0:
                    return this.$t("orders.statusList.pending");
                case 1:
                    return this.$t("orders.statusList.Assigned");
                case 2:
                    return this.$t("orders.statusList.inDelivery");
                case 3:
                    return this.$t("orders.statusList.delivered");
                case 4:
                    return this.$t("orders.statusList.Cancelled");
                case 5:
                    return this.$t("orders.statusList.collected");
                default:
                    return this.$t("orders.statusList.pending");
            }
        },

        startCountdowns() {
            this.products.forEach((product) => {
                if (!product.endCollectionTime) return;

                this.countdownIntervals[product.idVariant] = setInterval(() => {
                    // Met à jour la valeur de `remainingTime` avec la méthode existante
                    product.remainingTime = this.getRemainingTime(
                        product.endCollectionTime,
                        product
                    );

                    // Si le temps est dépassé, arrêtez l'intervalle
                    if (
                        product.remainingTime ===
                        product.purchaseOrderReference ||
                        product.remainingTime ===
                        this.$t("orders.CollectionCompleted")
                    ) {
                        clearInterval(
                            this.countdownIntervals[product.idVariant]
                        );
                    }
                }, 1000); // Exécution toutes les secondes
            });
        },

        getOrderDetails(orderId) {
            this.loader = true;
            getOrderById(orderId)
                .then((response) => {
                    const order = response.data;
                    this.idCommand = order.idCommand;
                    this.numCommand = order.numCommand;
                    this.status = order.status;
                    this.locationLabel = order.locationLabel;
                    this.locationAdresse = order.locationAdresse;
                    this.locationPostalCode = order.locationPostalCode;
                    this.locationLatitude = order.locationLatitude;
                    this.locationLongitude = order.locationLongitude;
                    this.createdDate = order.createdDate;
                    this.createdBy = order.createdBy;
                    this.client = order.client || { email: "", fullName: "" };
                    this.products = order.products.map((product) => ({
                        ...product,
                        remainingTime: this.getRemainingTime(
                            product.endCollectionTime,
                            product
                        ), // Initialisation
                    }));
                    this.startCountdowns();

                    this.commandTotalPrice = order.commandTotalPrice;
                    this.$emit("update-id-command", this.idCommand);
                })
                .catch((error) => {
                    console.error("Error fetching order details:", error);
                })
                .finally(() => {
                    this.loader = false;
                });
        },
        getRemainingTime(endTime, product) {
            if (endTime == null) {
                return product?.purchaseOrderReference || this.$t('orders.NotCollectingYet');
            }
            const now = new Date();
            const nowDate = Date.UTC(
                now.getUTCFullYear(),
                now.getUTCMonth(),
                now.getUTCDate(),
                now.getUTCHours(),
                now.getUTCMinutes(),
                now.getUTCSeconds()
            );
            const endTimeUTC = endTime.endsWith("Z") ? endTime : endTime + "Z";
            const endDate = new Date(endTimeUTC);
            const diffMs = endDate.getTime() - nowDate;
            if (diffMs < 0) {
                return (
                    product?.purchaseOrderReference ||
                    this.$t("orders.CollectionCompleted")
                );
            }

            let years = endDate.getUTCFullYear() - now.getUTCFullYear();
            let months = endDate.getUTCMonth() - now.getUTCMonth();
            let days = endDate.getUTCDate() - now.getUTCDate();
            let hours = endDate.getUTCHours() - now.getUTCHours();
            let minutes = endDate.getUTCMinutes() - now.getUTCMinutes();
            let seconds = endDate.getUTCSeconds() - now.getUTCSeconds();

            // Ajuster les valeurs si des sous-unités sont négatives
            if (seconds < 0) {
                seconds += 60;
                minutes -= 1;
            }

            if (minutes < 0) {
                minutes += 60;
                hours -= 1;
            }

            if (hours < 0) {
                hours += 24;
                days -= 1;
            }

            if (days < 0) {
                // Calcul des jours dans le mois précédent
                const previousMonth = new Date(
                    endDate.getUTCFullYear(),
                    endDate.getUTCMonth(),
                    0
                ).getDate();
                days += previousMonth;
                months -= 1;
            }

            if (months < 0) {
                months += 12;
                years -= 1;
            }

            // Construire le tableau des parties à afficher
            const parts = [];
            if (years > 0) parts.push(`${years}y`);
            if (months > 0) parts.push(`${months}m`);
            if (days > 0) parts.push(`${days}d`);
            if (hours > 0) parts.push(`${hours}h`);
            if (minutes > 0) parts.push(`${minutes}min`);
            if (seconds > 0) parts.push(`${seconds}s`);

            return parts.length > 0 ? parts.join(" ") : "Less than a second";
        },

        fetchPurchaseOrderDetails(idPurchaseOrder) {
            getPurchaseOrderById(idPurchaseOrder)
                .then((response) => {
                    this.selectedPurchaseOrder = response.data; // Stockez les données récupérées
                    this.editRequestDialog = true; // Affichez le composant de configuration
                })
                .catch((error) => {
                    console.error(
                        "Erreur lors de la récupération des détails du bon de commande :",
                        error
                    );
                })
                .finally(() => {
                    this.loader = false; // Masquer le loader après l'opération
                });
        },
    },
    computed: {
        mapEmbedUrl() {
            if (!this.locationLatitude || !this.locationLongitude) return "";
            return `https://www.google.com/maps/embed/v1/place?key=AIzaSyD-EXAMPLEKEY123456&q=${this.locationLatitude},${this.locationLongitude}&zoom=15`;
        },
        mapUrl() {
            if (!this.locationLatitude || !this.locationLongitude) return "";
            return `https://www.google.com/maps/search/?api=1&query=${this.locationLatitude},${this.locationLongitude}`;
        },
        // Calculer le montant total hors taxe
        totalAmountHT() {
            return this.products.reduce((total, product) => {
                return total + product.quantity * product.unitPrice;
            }, 0);
        },

        // Calculer les totaux des taxes par taux
        totaltaxs() {
            const taxTotals = {};
            this.products.forEach((product) => {
                const taxAmount =
                    product.quantity * product.unitPrice * (product.tax / 100);
                if (taxTotals[product.tax]) {
                    taxTotals[product.tax] += taxAmount;
                } else {
                    taxTotals[product.tax] = taxAmount;
                }
            });
            return taxTotals;
        },

        // Calculer le montant total TTC
        grandTotal() {
            return this.products.reduce((total, product) => {
                const taxMultiplier = 1 + product.tax / 100;
                return (
                    total + product.quantity * product.unitPrice * taxMultiplier
                );
            }, 0);
        },
    },
};
</script>

<style scoped>
.v-card-title {
    font-family: inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: #5b6d8e;
    margin-left: 12px;
    margin-bottom: 5px;
}

.readonly-field {
    background-color: #f5f5f5;
}


/* Location Map Styles */
.location-map-container {
    margin-top: 16px;
    border-radius: 8px;
    background-color: #f9fafb;
    padding: 16px;
}

.map-placeholder {
    height: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #f5f5f5;
    border-radius: 8px;
    color: #666;
}

.column-title {
    width: 25%;
}

.column-20 {
    width: 25%;
}

.column-small {
    width: 9%;
}

.column-time {
    width: 15%;
}

.table-responsive th,
.table-responsive td {
    text-align: center;
    padding: 8px;
    border: 1px solid #ddd;
    font-family: Inter, sans-serif;
    font-size: 14px;
}

.table-responsive th {
    background-color: #f5f5f5;
    font-weight: 600;
}

.totals p {
    margin: 5px 0;
}

.align-right {
    padding-right: 85px;
    text-align: right;
    position: relative;
}

.custom-divider {
    border-top: 1px solid;
    border-color: currentColor;
    width: 40%;
    margin-left: 60%;
}

.v-table--density-default>.v-table__wrapper>table>tbody>tr>td,
.v-table--density-default>.v-table__wrapper>table>thead>tr>td,
.v-table--density-default>.v-table__wrapper>table>tfoot>tr>td {
    padding: 2px;
}

.readonly-field {
    background-color: transparent;
}

.readonly-field .v-input__control {
    background-color: transparent !important;
}
</style>
